import { Box, Button, useColorModeValue } from '@chakra-ui/react'
import { useRecoilValue } from 'recoil'

import { circlesBreakpointState } from '../../../state'
import { BITCOIN_ORANGE, menuLabelFontSize } from '../../../constants'
import { getBreakpointValue } from '../../../utils'
import type { MouseEventHandler } from 'react'
import { FormattedMessage } from 'react-intl'

interface GalleryButtonProps {
	onClick: MouseEventHandler
}

export const TCGalleryButton = ({
	onClick,
	...rest
}: GalleryButtonProps) => {
	const circlesBreakpoint = useRecoilValue(circlesBreakpointState)

	const interactionStyle = {
		borderColor: BITCOIN_ORANGE,
		color: BITCOIN_ORANGE,
	}
	const responsiveButtonLabelSize = getBreakpointValue(menuLabelFontSize, circlesBreakpoint)
	const buttonHeight = getBreakpointValue({ base: '30px', md: '38px' }, circlesBreakpoint)
	const buttonLineHeight = getBreakpointValue({ base: '26px', md: '36px' }, circlesBreakpoint)
	const bg = useColorModeValue('white', 'black')
	const color = useColorModeValue('black', 'white')

	return (
		<Box
			className="tc-gallery-button-wrap"
			onClick={onClick}
			cursor="pointer"
			role="group"
			pos="relative"
			zIndex={1015}
			{...rest}
		>
			<Button
				className="tc-gallery-button"
				w="100%"
				size="sm"
				variant="outline"
				bg={bg}
				fontSize={responsiveButtonLabelSize}
				height={buttonHeight}
				lineHeight={buttonLineHeight}
				textTransform="uppercase"
				py="0"
				px="12px"
				color={color}
				borderColor={color}
				borderWidth={2}
				borderRadius="md"
				_active={interactionStyle}
				_hover={interactionStyle}
				_groupHover={interactionStyle}
			>
				<FormattedMessage id="gallery.button_label" />
			</Button>
		</Box>
	)
}
